module.exports = __webpack_public_path__ + "img/real-time.91200d4d.png";